import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { type FC } from "react";

import * as Styled from "./NoteCell.styles";

interface INoteCellProps {
  text: string;
}

export const NoteCell: FC<INoteCellProps> = ({ text }) => (
  <Styled.Root>
    <FilterAltIcon />
    {text}
  </Styled.Root>
);
